<template>
    <div>
      <div v-for="error in errors">
        <el-alert
            :title="error"
            type="warning">
        </el-alert>
      </div>

      <el-dialog title="Move Components"
                 :visible.sync="isShowingMove">
        <el-select filterable v-model="selected_report" >
          <el-option
              v-for="report in reports"
              :key = "report.id"
              :label = "report.title"
              :value = "report.id">
          </el-option>
        </el-select>
        <el-button @click="bulkMove">Move components to selected report</el-button>
      </el-dialog>

      <div v-if="data_ready">
        <el-dialog title="Add Component"
                   :close-on-click-modal="false"
                   :visible.sync="show_edit">
          <FormManager
              :events="events"
              :initialFormValues="definition_for_editor"
              @save="save"
              :prettyEndPoint="'/reports/pretty_report_comps/' + report_id" />
        </el-dialog>
      </div>

        <div v-if="data_ready" >
            <h1 class="report-title">{{report_definition.title}}
              <span class="report-editing-controls" style="float:right">
                <span v-if="global_edit_mode">
                  <span v-if="checked_items.length>0" style="background:lightgray;padding:20px;">
                    <strong style="font-size:14px;">Bulk actions</strong>
                      <el-button @click="showMove" style="">Move</el-button>
                  </span>
                  <el-button @click="blank_editor" style="margin-bottom:20px;">Add</el-button>
                </span>
                <el-switch
                    v-if="permissions.includes('GRAPH_CUSTOM')"
                  v-model="global_edit_mode"
                  active-text="Edit"
                  inactive-text="View"
                  active-color="#d62828"
                  inactive-color="#eae2b7"
                >
                </el-switch>
                <span v-if="!global_edit_mode">
                  <el-button icon="el-icon-data-board" @click="start_presentation"></el-button>
                  <el-button v-if="presentation_mode" icon="el-icon-caret-right" @click="jump(first_jump)"></el-button>
                </span>
              </span>
            </h1>

            <p>Generated at {{timestamp}}</p>
          <div v-if="additional_filters.length>0" style="margin-bottom:15px;background-color:#eeeeee;padding:20px;">
            <div><strong>Filters</strong></div>
            <span v-for="filter_set in additional_filters"  :style="filter_set.must_select && !filter_set.is_set ? 'margin-top:30px;padding:10px;background-color:red;color:white;' : ''">
              <span v-for="filter_pair in filter_set.filter_pairs">
                <span v-if="filter_set.editable">
                  {{filter_pair.field_name}} =
                  <el-select filterable allow-create v-model="filter_pair.field_value" @change = "select_value_changes(filter_set.id)"
                  >
                      <el-option
                          v-for="popular_value in filter_pair.popular_values"
                          :key = "popular_value.value"
                          :label = "popular_value.value"
                          :value = "popular_value.value"
                      >
                      </el-option>
                  </el-select>
                </span>
                <span v-else>
                  {{filter_pair.type}}: {{filter_pair.field_name}} = {{filter_pair.field_value}}
                </span>
              </span>
            </span>
            <!---

            --->
          </div>

          <div v-if="unset_required_filter">
            <h1>In this report, you must first select values for the field(s) highlighted in red above.</h1>
          </div>
          <div v-else v-for="row in rows" class="row">
                <div v-for="component_definition in row">
                  <div v-if="component_definition.details_type==='App\\ReportCompSectionBreak'"
                       :style="component_definition.columns===12 ? 'margin-top:' + section_top_margin + 'px' : ''">.
                  </div>
                  <a v-if="component_definition.slug" :name="component_definition.slug" :ref="component_definition.slug"></a>
                  <ReportComp
                        :definition="component_definition"
                        :edit_mode="global_edit_mode"
                        @addedFilters="addedFilters($event,component_definition.id)"
                        @reload="load_definition"
                        :additional_filters="active_flattened_filters"
                        :presentation_mode="presentation_mode"
                        @jump="jump($event)"
                        :margin_width="30*(row.length-1)"
                        @checked="checked($event)"
                        :snapshotId="report_definition.snapshot_id"
                    />
                </div>
            </div>
            <p>
                <a href="https://chimera.davidhobbsconsulting.com">
                Generated by Content Chimera
                </a>.
            </p>
          <span class="report-editing-controls" style="float:right;margin-bottom:20px;">
              <span v-if="global_edit_mode">
                <el-button @click="blank_editor" style="margin-bottom:20px;">Add</el-button>
              </span>
              <el-switch
                  v-model="global_edit_mode"
                  active-text="Edit"
                  inactive-text="View"
                  active-color="#d62828"
                  inactive-color="#eae2b7"
              >
            </el-switch></span>
        </div>
    </div>
</template>

<script>
    export default {
      name: "Report",
      props: ['report_id','query'],
      data() {
        return {
          permissions: null,
          isShowingMove: false,
          checked_items: [],
          reports: null,
          selected_report: null,
          errors: [],
          // Additional filters has an array per visual filter, keyed on the visual filter id -- each element could have multiple filter test pairsA
          // active_flattened_filters takes out all the keys and returns a flattened array just with the filters
          additional_filters: [],
          active_flattened_filters: [],
          report_definition: null,
          rows: null,
          data_ready: false,
          show_edit: false,
          global_edit_mode: false,
          events: {
            use: {
              label: "Save" ,
              event: "save"
            },
            cancel: {
              label: "Cancel",
              event: "cancel"
            }
          },
          definition_for_editor: {
              type: 'section_break',
              report_id: null,
              columns: 12,
              order: 1
          },
          presentation_mode: false,
          first_jump: '',
          scrolled: false,
          headers: [],
          unset_required_filter: false,
        }
      },
      computed: {
        timestamp: function () {
          return new Date().toLocaleString();
        },
        section_top_margin: function() {
          return this.presentation_mode ? 1000 : 0
        },
      },
      updated() {
        if (! this.scrolled && window.location.hash !== '') {
          this.$nextTick(function () {
            const scrollTo = window.location.hash.replace('#', '');
            if (this.$refs[scrollTo] !== undefined) {
              this.$refs[scrollTo][0].scrollIntoView();
              this.scrolled = true;
            }
          })
        }
      },
      mounted() {
        this.data_ready = false
        this.load_definition()
        this.permissions = chimera.permissions
      },
      watch: {
        global_edit_mode () {
          if (this.global_edit_mode) this.presentation_mode = false
        },
      },
      methods: {
        select_value_changes(filter_set_id) {
          let existing = this.additional_filters.find(item => item.id === filter_set_id)
          existing.is_set = true

          this.additional_filters = this.additional_filters.map(item => {
            if (item.id === filter_set_id) item.is_set = true
            return item
          })

          this.calculate_flattened_filters()
        },
        calculate_flattened_filters() {
          this.active_flattened_filters = [];
          this.unset_required_filter = false
          this.additional_filters.forEach(filter => {
            if (filter.must_select && !filter.is_set) {
              this.unset_required_filter = true
            } else {
              filter.filter_pairs.forEach(pair => {
                let new_pair = {
                  type: filter.type,
                  editable: filter.editable,
                  field_name: pair.field_name,
                  field_value: pair.field_value,
                }
                if (filter.is_set) {
                  this.active_flattened_filters.push(new_pair)
                }
              })
            }
          })
        },
        get_headers() {
          axios.get('/api/flattened/metadata_extended/' + this.report_definition.flattened_in_charts.main_table.id)
              .then(response => {
                this.headers = response.data.columns
                this.additional_filters = []
                this.report_definition.filters.forEach(filter => {
                  let filter_pairs = [{
                    field_name: filter.field_name,
                    field_value: filter.field_value,
                  }]
                  let my_id = 'report.' + filter.id
                  this.additional_filters.push({
                    filter_pairs: this.add_popular_values_to_filter_pairs(filter_pairs),
                    editable: true,
                    is_set: !!filter.field_value,
                    must_select: !!filter.must_select,
                    my_id: my_id
                  })
                })
                let filters_from_url = this.query.split(';').filter(item => item !== '')
                filters_from_url.forEach(pair => {
                  let pair_as_array = pair.split(',')
                  // later we probably want to allow arbitrary values (regardless of whether there's a report filter predefined),
                  // but for now we'll just look to see if it currently exists
                  this.additional_filters = this.additional_filters.map(filter_set => {
                    // This isn't *quite* right in the event that there's a visual filter and a pulldown filter on the same field simultaneously
                    let field_name = pair_as_array[0]
                    let field_value = pair_as_array[1]
                    let is_set = false
                    filter_set.filter_pairs.map(filter_pair => {
                      if (filter_pair.field_name === field_name || filter_pair.field_name === field_name.replace('_',' ')) {
                        filter_pair.field_value = field_value
                        is_set = true
                      }
                      return filter_pair
                    })
                    filter_set.is_set = is_set
                    return filter_set
                  })
                })
                this.calculate_flattened_filters()
                this.have_header_data = true
              })
              .catch(error => {
                console.log('could not load extended metadata')
              })
        },
        jump(slug="top") {
          location.href = "#"+slug;                 //Go to the target element.
        },
        start_presentation() {
          this.presentation_mode = !this.presentation_mode
        },
        add_popular_values_to_filter_pairs(filter_pairs) {
          return filter_pairs.map(pair => {
            let matching = this.headers.filter(header => {
              return header.display_name === pair.field_name
            })
            if (matching.length > 0) {
              pair.popular_values = matching[0].popular_values
            } else {
              pair.popular_values = []
            }
            return pair
          })
        },
        addedFilters(payload,visual_filter_id) {
          let type = 'visual_filter'
          let id = type + '.' + visual_filter_id
          let existing = this.additional_filters.find(item => item.id === id)
          if (payload) {
            let filter_pairs = this.add_popular_values_to_filter_pairs(payload)
            if (existing) {
              existing.filter_pairs = this.filter_pairs
            } else {
              this.additional_filters.push({
                id: id,
                filter_pairs: filter_pairs,
                type: type,
                editable: false,
                is_set: true,
              })
            }
          } else {
            // deselecting a visual filter value needs to take out the filter pair
            this.additional_filters = this.additional_filters.filter(item => item.id === id)
          }
          this.calculate_flattened_filters()
        },
        async showMove() {
            try {
              if (!this.reports) {
                const {data} = await axios.get("/api/user/reports");
                this.reports = data.list;
              }
              this.isShowingMove = true
            } catch (error) {
              console.error(error);
            }
        },
        bulkMove() {
          axios.patch('/api/reports/move/' + this.report_id + '/' + this.selected_report, {
            components: this.checked_items
          }).then(response => {
            this.isShowingMove = false
          }).catch(error => {
            console.log('oops save')
            console.log(error)
          })
        },
        checked(payload) {
          if (payload.checked) {
            this.checked_items.push(payload.id)
          } else {
            // https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array
            const index = this.checked_items.indexOf(payload.id);
            if (index > -1) {
              this.checked_items.splice(index, 1);
            }
          }
        },
        blank_editor() {
          this.definition_for_editor = {
            type: 'section_break',
            report_id: Number(this.report_id),
            columns: 12,
            order: 1,
            chart_config: null,
            details_id: null,
            id: null,
            text: '',
            title: ''
          }
          this.show_edit = true
        },
        save(values) {
          axios.post('/reports/comps/' + this.report_id, {
            comp: values
          })
              .then(response => {
                this.load_definition()
                this.show_edit = false
              })
              .catch(error => {
                console.log('oops could not save')
              })
        },
        load_definition() {
          window.axios.get('/reports/definition/' + this.report_id)
              .then(response => {
                this.report_definition = response.data.definition
                this.errors = response.data.errors
                // Much of this rows/columns logic is identical to what's in ReportCompSmallMult
                this.rows = []
                let current_row = []
                let row_col_max = 12
                let row_col_count = 0
                let count = 0
                let jump_points = []
                let jump_index = 0
                this.report_definition.components.forEach(component => {
                  if (component.details_type==='App\\ReportCompSectionBreak' && component.columns===12) {
                    if (jump_index===0) this.first_jump = component.slug
                    jump_points[jump_index] = component.slug
                    jump_index++
                  }
                })
                let jump_max = jump_index - 1
                jump_index = 0
                this.report_definition.components.forEach(component => {
                  if (row_col_count >= row_col_max) {
                    this.rows.push(current_row)
                    current_row = []
                    row_col_count = 0
                  }
                  row_col_count += component.columns
                  count = count + 1
                  component.css_id = "chart-" + count
                  if (component.details_type==='App\\ReportCompSectionBreak' && component.columns===12) {
                    let next_jump = jump_index + 1
                    if (next_jump<=jump_max) {
                      component.next_jump = jump_points[next_jump]
                    } else {
                      component.next_jump = 'top'
                    }
                    jump_index = next_jump
                  } else {
                    component.next_jump = null
                  }
                  current_row.push(component)
                })
                this.rows.push(current_row)
                // can only get the headers after we get the definition
                this.get_headers()
                this.data_ready = true
              })
              .catch(error => {
                console.log("Could not get report definition")
              })
        },
      }
    }
</script>
